import {
    CREATECATEGORY_SUCCESS, CREATECATEGORY_FAIL,
} from "../actionTypes";

const initialState = {
    user: null,
};

const createCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATECATEGORY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload,
            };
        case CREATECATEGORY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createCategoryReducer;
